import React, {useEffect, useState} from 'react';
import {Row, Col, Input, Form, Spin, Modal} from 'antd';
import { Link } from 'react-router-dom'
import './BasicInfoAlert.scss';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { camelizerHelper } from '../../../../helpers';
import { ModalClientCard } from '../../../Register/components';

const BasicInfoAlert = ({ alert, currentUser}) => {
    const [risks, setRisks] = useState([])
    const [itemsTotalNum, setItemsTotalNum] = useState(0)
    const [currentPageRisk, setCurrentPageRisk] = useState(1)
    const [isModalClientCardOpen, setIsModalClientCardOpen] = useState(false)
    const [modalTitleButtons, setModalTitleButtons] = useState(null)
    const itemsPerPage = 10
    const { t } = useTranslation('translations')

    useEffect(() => {
        if(alert?.risks?.length > 0) {
            handlePaginationChange(1)
            setItemsTotalNum(alert.risks.length)
        }
    }, []);

    const handlePaginationChange = (page) => {
        const fromNum = ((page - 1) * itemsPerPage)
        setCurrentPageRisk(page)
        setRisks(alert.risks.slice(fromNum, fromNum + itemsPerPage))
    }

    const ifNullText = (data) => {
        if (data) {
            return data
        }
        return t('messages.aml.nA')
    }

    const handleCloseModalFicha = () => {
        setIsModalClientCardOpen(false)
    }

    return (
        <>
            { alert ? 
                <div className='basic-info-alert-section'>
                    <div className="title-section">
                        <Row>
                            <Col span={19}>
                                <h3>{camelizerHelper(alert.record?.nombre)}</h3>
                            </Col>
                            <Col span={5}>
                                <div style={{textAlign: 'right'}}>
                                    {t('messages.aml.modalAlert.alertReception')}{' '}
                                    {moment(alert.creationDate).format('DD/MM/YYYY')}
                                </div>
                            </Col>
                        </Row>
                        <hr/>
                    </div>
                    <Form colon={false}>
                        <div className='subtitle-section'>
                            <Row>
                                <Col span={24}>
                                    {t('messages.aml.modalAlert.section.person')}
                                </Col>
                            </Row>
                        </div>
                        <div className='body-section-wrapper'>
                            <Row gutter={[36]}>
                                <Col span={6}>
                                    <Form.Item label={t('messages.aml.modalAlert.documentType')}>
                                        <Input readOnly value={ifNullText(alert.record?.tipoDoc)}/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label={t('messages.aml.modalAlert.documentNumber')}>
                                        <Input 
                                            readOnly 
                                            value={ifNullText(alert.record?.rut)}
                                            onClick={() => setIsModalClientCardOpen(true)}
                                            style={{cursor: 'pointer', color: '#1890ff'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label={t('messages.aml.modalAlert.personType')}>
                                        <Input readOnly value={(alert.typePerson ? alert.typePerson : alert.record?.type) === 'Person' ? t('messages.aml.modalAlert.personNatural') : t('messages.aml.modalAlert.personLegal')}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        {alert.contratante?.typePEP && alert.contratante?.typePEP !== 'T' && alert.contratante?.rutPEPTitular &&
                            <>
                                <div className='subtitle-section'>
                                    <Row>
                                        <Col span={24}>
                                            {t('messages.aml.modalAlert.sectionPep')}
                                        </Col>
                                    </Row>
                                </div>
                                <div className='body-section-wrapper'>
                                    <Row gutter={[36]}>
                                        <Col span={6}>
                                            <Form.Item label={t('messages.aml.modalAlert.pepHolderName')}>
                                                <Input readOnly value={ifNullText(camelizerHelper(alert.contratante?.nombrePEPTitular))}/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item label={t('messages.aml.modalAlert.pepHolderDocument')}>
                                                <Input readOnly value={ifNullText(alert.contratante?.rutPEPTitular)}/>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </>
                        }
                        {alert.record &&
                            <>
                                <div className='subtitle-section'>
                                    <Row>
                                        <Col span={24}>
                                            {t('messages.aml.modalAlert.sectionAdditionalInfo')}
                                        </Col>
                                    </Row>
                                </div>
                                <div className='body-section-wrapper'>
                                    <Row gutter={[36]}>
                                        <Col span={6}>
                                            <Form.Item label={t('messages.aml.modalAlert.birthDate')}>
                                                <Input readOnly value={alert.record?.dateBirth ? moment(alert.record.dateBirth).format('DD/MM/YYYY') : t('messages.aml.nA')}/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item label={t('messages.aml.modalAlert.nationality')}>
                                                <Input readOnly value={ifNullText(alert.record?.citizenship)}/>
                                            </Form.Item>
                                        </Col>
                                        {alert.contratante &&
                                            <>
                                                { alert.contratante.actividadEconomica &&
                                                    <Col span={6}>
                                                        <Form.Item label={t('messages.aml.modalAlert.activity')}>
                                                            <Input readOnly value={ifNullText(alert?.contratante?.actividadEconomica)}/>
                                                        </Form.Item>
                                                    </Col>
                                                }
                                                { alert.contratante.comunaParticular &&
                                                    <Col span={6}>
                                                        <Form.Item label={t('messages.aml.modalAlert.comunaParticular')}>
                                                            <Input readOnly value={ifNullText(alert?.contratante?.comunaParticular)}/>
                                                        </Form.Item>
                                                    </Col>
                                                }
                                                { alert.contratante.comunaComercial &&
                                                    <Col span={6}>
                                                        <Form.Item label={t('messages.aml.modalAlert.comunaComercial')}>
                                                            <Input readOnly value={ifNullText(alert?.contratante?.comunaComercial)}/>
                                                        </Form.Item>
                                                    </Col>
                                                }
                                                { alert.contratante.perfil &&
                                                    <Col span={6}>
                                                        <Form.Item label={t('messages.aml.modalAlert.riskProfile')}>
                                                            <Input readOnly value={alert.contratante.perfil}/>
                                                        </Form.Item>
                                                    </Col>
                                                }
                                                { alert.contratante.primerAporte &&
                                                    <Col span={6}>
                                                        <Form.Item label={t('messages.aml.modalAlert.firstContribution')}>
                                                            <Input readOnly value={ifNullText(alert?.contratante?.primerAporte)}/>
                                                        </Form.Item>
                                                    </Col>
                                                }
                                                { alert.contratante.patrimonioAdministrar &&
                                                    <Col span={6}>
                                                        <Form.Item label={t('messages.aml.modalAlert.assetsToManage')}>
                                                            <Input readOnly value={ifNullText(alert?.contratante?.patrimonioAdministrar)}/>
                                                        </Form.Item>
                                                    </Col>
                                                }
                                            </>
                                        }
                                    </Row>
                                </div>
                            </>
                        }

                            <div className='subtitle-section'>
                                <Row>
                                    <Col span={24}>
                                        {t('messages.aml.modalAlert.sectionAlert')}
                                    </Col>
                                </Row>
                            </div>
                            <div className='body-section-wrapper'>
                                <Row gutter={[36]}>
                                    <Col span={5}>
                                        <Form.Item label={t('messages.aml.modalAlert.folio')}>
                                            <Input readOnly value={alert?.folio}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={5}>
                                        <Form.Item label={t('messages.aml.modalAlert.state')}>
                                            <Input readOnly value={t("messages.aml.alert.status."+alert?.status)}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={5}>
                                        <Form.Item label={t('messages.aml.modalAlert.riskType')}>
                                            <Input readOnly value={t("messages.aml.risk."+alert?.type)}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item label={t('messages.aml.modalAlert.alertRiskScore')}>
                                            <Input readOnly value={alert?.score}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={5}>
                                        <Form.Item label={t('messages.aml.modalAlert.alertTime')}>
                                            <Input readOnly value={alert.days > 1 ? `${alert.days} ${t('messages.aml.modalAlert.days')}` : `${alert.days} ${t('messages.aml.modalAlert.day')}`}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                    </Form>
                </div>
            :
                <div style={{textAlign: 'center', padding: 100}}>
                    <Spin size="large"/>
                </div>
            }
            {isModalClientCardOpen &&
                <Modal
                    wrapClassName="modal-fichaCliente-register"
                    style={{top:'10px'}}
                    visible={true}
                    onCancel={handleCloseModalFicha}
                    cancelText={t('messages.aml.btnClose')}
                    footer={null}
                    width={'95vw'}
                    title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <span>{t('messages.aml.register')}</span>
                            {modalTitleButtons}
                        </div>
                    }
                >
                    <ModalClientCard
                        item={alert.record} 
                        handleCancel={handleCloseModalFicha} 
                        currentUser={currentUser} 
                        onTitleButtons={(buttons) => setModalTitleButtons(buttons)}
                    />
                </Modal>
            }
        </>
    );
};

export default BasicInfoAlert;